import React from "react";

const MarketSidebar = ({
  indices,
  economicEvents,
  gainers,
  losers,
  commodities,
}) => {
  return (
    <aside className="space-y-6">
      {/* Indices */}
      <div className="bg-surface-default dark:bg-surface-default rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Market Indices
        </h3>
        <div className="space-y-2">
          {indices &&
            indices.map((idx) => (
              <div key={idx.name} className="flex justify-between items-center">
                <span className="text-gray-900 dark:text-gray-100">{idx.name}</span>
                <span className={`text-${idx.color}-600 font-medium`}>
                  {idx.value} {idx.change} ({idx.percentChange})
                </span>
              </div>
            ))}
        </div>
      </div>
      {/* Gainers & Losers Side by Side */}
      <div className="bg-surface-default dark:bg-surface-default rounded-lg shadow p-6">
        <div className="grid grid-cols-2 gap-4">
          {/* Gainers */}
          <div>
            <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Gainers</h3>
            <div className="space-y-2">
              {gainers &&
                gainers.map((g) => (
                  <div
                    key={g.symbol}
                    className="flex justify-between items-center"
                  >
                    <span className="font-medium text-gray-900 dark:text-gray-100">
                      {g.symbol}
                    </span>
                    <span className="text-green-600">
                      {g.change} ({g.percentChange})
                    </span>
                  </div>
                ))}
            </div>
          </div>
          {/* Losers */}
          <div>
            <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Losers</h3>
            <div className="space-y-2">
              {losers &&
                losers.map((l) => (
                  <div
                    key={l.symbol}
                    className="flex justify-between items-center"
                  >
                    <span className="font-medium text-gray-900 dark:text-gray-100">
                      {l.symbol}
                    </span>
                    <span className="text-red-600">
                      {l.change} ({l.percentChange})
                    </span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      {/* Commodities */}
      <div className="bg-surface-default dark:bg-surface-default rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Commodities
        </h3>
        <div className="space-y-3">
          {commodities &&
            commodities.map((c) => (
              <div key={c.name} className="flex justify-between items-center">
                <span className="text-gray-900 dark:text-gray-100">{c.name}</span>
                <span className={`text-${c.color}-600`}>
                  {c.value} {c.change}
                </span>
              </div>
            ))}
        </div>
      </div>
    </aside>
  );
};

export default MarketSidebar;
